import { useTheme } from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const Spinner = ({ color, size = "2x", ...restProps }) => {
  const theme = useTheme();
  return (
    <div className={`${restProps.className}`} {...restProps}>
      <FontAwesomeIcon
        icon={faSpinner}
        size={size}
        color={color || theme.primary}
        spin={true}
      />
    </div>
  );
};

export default Spinner;
